import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Observable } from 'rxjs';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Tabel } from 'src/app/interfaces/auth.interface';
import { Router } from '@angular/router';

@Component({
  selector: 'app-changeno',
  templateUrl: './changeno.component.html',
  styleUrls: ['./changeno.component.scss']
})
export class ChangenoComponent implements OnInit {

  // @Input('tableno') info: Tabel;

  tableno:number = null

  linkRef: AngularFirestoreDocument<any>;

  link: Observable<any>;

  tabel: Tabel[] = [];

  id: string = '' 

  constructor(private as: AuthService, private fs: AngularFirestore, private router:Router) { }

  ngOnInit(): void {
    
    this.as.user.subscribe(user => {
      
      if(user) { this.id = user.uid; }

      this.linkRef = this.fs.collection('users').doc(`${this.id}`)
   
      this.link = this.linkRef.valueChanges();
 
      this.link.subscribe(data=> {
        this.tableno = data.tableno
      })
      
    })
  }

  updateNo(tableno){
    this.fs.collection('users').doc(`${this.id}`).update({tableno})
   .then(()=> {
     this.router.navigate(['/'])
   })
 }

}
